<template>
  <div class="modal fade" id="survey-link-qr-modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered sv-qr-dialog" role="document">
      <div class="modal-content sv-qr-modal">
        <div class="sv-qr-header" :class="headerClass">
          <div class="sv-qr-header-icon">
            <i class="bi bi-qr-code"></i>
          </div>
          <div class="sv-qr-header-text">
            <h5 class="mb-0">Survey Link</h5>
            <p class="mb-0">
              {{ survey.activity_title }}
              <span v-if="survey.name"> · {{ survey.name }}</span>
            </p>
          </div>
          <button type="button" class="sv-qr-close" data-dismiss="modal" aria-label="Close">
            <i class="bi bi-x-lg"></i>
          </button>
        </div>

        <div class="modal-body sv-qr-body">
          <div class="sv-qr-badges">
            <span v-if="survey.survey_type_label" class="sv-qr-badge type">
              {{ survey.survey_type_label }}
            </span>
            <span class="sv-qr-badge secure">
              <i class="bi bi-shield-lock"></i> Secure session link
            </span>
          </div>

          <div class="sv-qr-frame">
            <canvas ref="qrCanvas"></canvas>
          </div>

          <div class="sv-qr-link-row">
            <input ref="linkInput" :value="survey.survey_url" class="form-control" readonly />
            <button type="button" class="sv-qr-copy" @click="copyLink">
              <i class="bi bi-clipboard"></i>
            </button>
          </div>

          <div class="sv-qr-meta">
            <div class="meta-chip">
              <i class="bi bi-clock"></i>
              Valid until <strong>{{ formatExpiry }}</strong>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import QRCode from "qrcode";
import moment from "moment";

export default {
  name: "SurveyLinkQrModal",
  data() {
    return { survey: {} };
  },
  computed: {
    formatExpiry() {
      return this.survey.expires_at
        ? moment(this.survey.expires_at).format("MMM D, YYYY h:mm A")
        : "";
    },
    headerClass() {
      return this.survey.survey_type === "face-to-face" ? "header-f2f" : "";
    },
  },
  methods: {
    open(survey) {
      this.survey = survey || {};
      $("#survey-link-qr-modal").modal("show");
      this.$nextTick(() => this.renderQr());
    },
    async renderQr() {
      const canvas = this.$refs.qrCanvas;
      if (!canvas || !this.survey.survey_url) return;
      await QRCode.toCanvas(canvas, this.survey.survey_url, {
        width: 200,
        margin: 2,
        color: { dark: "#2b3a55", light: "#ffffff" },
      });
    },
    copyLink() {
      const input = this.$refs.linkInput;
      if (!input) return;
      input.select();
      document.execCommand("copy");
      toastr.success("Survey link copied.", "Copied");
    },
  },
};
</script>

<style scoped>
.sv-qr-dialog { max-width: 400px; }

.sv-qr-modal {
  border: none;
  border-radius: 18px;
  overflow: hidden;
  box-shadow: 0 20px 60px rgba(43, 58, 85, 0.18);
}

.sv-qr-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1.1rem 1.25rem;
  background: linear-gradient(135deg, #4d8dff 0%, #3a7ae8 100%);
  color: #fff;
}

.sv-qr-header.header-f2f {
  background: linear-gradient(135deg, #2bb6a3 0%, #1f9a8a 100%);
}

.sv-qr-header-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.1rem;
  flex-shrink: 0;
}

.sv-qr-header-text { flex: 1; min-width: 0; }
.sv-qr-header-text h5 { font-weight: 700; font-size: 1rem; }
.sv-qr-header-text p {
  font-size: 0.78rem;
  opacity: 0.85;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.sv-qr-close {
  background: rgba(255, 255, 255, 0.15);
  border: none;
  color: #fff;
  width: 32px;
  height: 32px;
  border-radius: 8px;
  cursor: pointer;
}

.sv-qr-body { padding: 1.25rem; }

.sv-qr-badges {
  display: flex;
  gap: 0.4rem;
  flex-wrap: wrap;
  margin-bottom: 1rem;
}

.sv-qr-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.3rem;
  font-size: 0.72rem;
  font-weight: 600;
  padding: 0.2rem 0.55rem;
  border-radius: 6px;
}

.sv-qr-badge.type { background: rgba(77, 141, 255, 0.12); color: #4d8dff; }
.sv-qr-badge.secure { background: rgba(43, 182, 163, 0.12); color: #1f8f7f; }

.sv-qr-frame {
  display: flex;
  justify-content: center;
  padding: 1.25rem;
  background: #f8f9fb;
  border-radius: 14px;
  margin-bottom: 1rem;
}

.sv-qr-link-row {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.sv-qr-link-row input {
  font-size: 0.78rem;
  border-radius: 10px;
  background: #f8f9fb;
}

.sv-qr-copy {
  width: 40px;
  border: 1px solid rgba(0, 0, 21, 0.1);
  background: #fff;
  border-radius: 10px;
  color: #4d8dff;
  cursor: pointer;
}

.meta-chip {
  font-size: 0.78rem;
  color: #768192;
  background: #f0f3f8;
  padding: 0.3rem 0.6rem;
  border-radius: 8px;
}
</style>
